module.exports = __webpack_public_path__ + "img/icon_onInfo.a7fbb037.svg";